import React from 'react';
import { Column, Row } from 'types/Table';
import { CardProps } from 'types/CardComponents';

export const Card = ({
    results,
    rowClicked,
    className,
    headers = [],
}: CardProps) => {
    const getBodyText = (column: Column | string): React.ReactNode => {
        if (typeof column === 'string') {
            return column;
        }
        return column?.body || '';
    };

    const specialLowercase = (theString: string): string =>
        theString.toLowerCase().replace(/ id/, ' ID');

    const defaultLinkClicked = (link: (() => void) | string): void => {
        if (typeof link === 'function') {
            link();
        }
    };

    const findCardTitle = (card: Row): [string, number] => {
        let foundTitle: string | boolean = '';
        let cardTitleIndex = -1;

        card.columns?.forEach((column, i) => {
            if (typeof column === 'object' && column?.cardTitle) {
                let header = headers[i] || '';
                foundTitle = typeof header === 'object' ? header.body ?? '' : header;
                cardTitleIndex = i;
                foundTitle += (foundTitle ? ': ' : '') + column.cardTitle;
            }
        });

        return [foundTitle, cardTitleIndex];
    };

    const handleRowClick = (card: Row) => {
        if (card.rowLink) {
            if (typeof rowClicked === 'function') {
                rowClicked(card);
            } else if (rowClicked !== false) {
                defaultLinkClicked(card.rowLink);
            }
        }
    };

    return (
        <div className="table-container is-card card-container">
            {results.map((card, card_index) => {
                const [cardTitle, cardTitleIndex] = findCardTitle(card);
                const handleClick = () => handleRowClick(card);

                const cardTitleHtml = cardTitle ? (
                    <div className="card-title" onClick={handleClick}>
                        {specialLowercase(cardTitle)}
                    </div>
                ) : null;

                return (
                    <div key={`card-${card_index}`} className={`card ${className || ''}`}>
                        {cardTitleHtml}
                        <div className="card-body">
                            {card.columns?.map((column, i) => {
                                if (!column || (typeof column === 'object' && !column.body)) {
                                    return null;
                                }


                                if (typeof column === 'object' && column.cardHidden === true) {
                                    return (
                                        <span
                                            key={`column-${i}-removed`}
                                            className="column-removed"
                                        />
                                    );
                                }

                                if (i === cardTitleIndex) {
                                    return (
                                        <span
                                            key={`column-${i}-removed`}
                                            className="column-removed"
                                        />
                                    );
                                }

                                const header = headers[i] || '';
                                const headerText = typeof header === 'object' ? header.body || '' : header;
                                const headerClass = typeof header === 'object' ? header.className || '' : '';

                                const titleHtml = headerText && typeof headerText === 'string' ? (
                                    <div className={`title ${headerClass}`} onClick={handleClick}>
                                        {specialLowercase(headerText)}:
                                    </div>
                                ) : null;

                                const columnBody = getBodyText(column);
                                const columnClass = typeof column === 'object' ? column.className || '' : '';

                                return columnBody ? (
                                    <div
                                        key={`card-${i}-body`}
                                        className={`card-body-row ${!headerText ? 'card-no-header' : ''}`}
                                        onClick={handleClick}
                                    >
                                        {titleHtml}
                                        <span className={`body ${columnClass}`}>
                                            {columnBody}
                                        </span>
                                    </div>
                                ) : null;
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
